export const getTypeByMime = (mime?: string | null) => {
  if (mime?.startsWith("image")) return "image";
  if (mime?.startsWith("video")) return "video";

  return "raw";
};
